import { type RefObject } from 'react';
import { useIntersectionListener } from '@direct-frontend/stdlib';
import { useScrollRef } from './ScrollContext';
import styles from './Stick.module.css';

export interface StickyProps {
    target: RefObject<HTMLElement>;
    children: (parameters: { isSticky: boolean; stickStyle: string; style: string }) => React.ReactElement | null;
    threshold?: number;
}

export const Sticky = ({ children, target, threshold }: StickyProps) => {
    const scrollRef = useScrollRef();

    const { isIntersected } = useIntersectionListener({ root: scrollRef, target, threshold });

    return children({
        isSticky: !isIntersected,
        stickStyle: styles.sticky,
        style: styles.unsticky,
    });
};
